/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-clone-md': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.772 1a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 .5.5v8.727a.5.5 0 0 1-.5.5H9.727a.5.5 0 1 1 0-1H12.5V1.5H4.772v2.773a.5.5 0 0 1-1 0V1z" _fill="#234357"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M.5 4.272a.5.5 0 0 1 .5-.5h8.727a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V4.272zm1 .5V12.5h7.727V4.772H1.5z" _fill="#234357"/>'
  }
})
